import { Input } from '@frontend/design_system'
import { TrashIconWithBg } from 'ui/icons'
import { DriverAgeRangeType } from 'api/fleet/types'
import { DriverAgeRangeProps } from './types'
import { onlyNumbersWithOneDotRegex } from 'constants/regex'
import styles from './styles.module.scss'
import { DRIVER_AGE_RANGE } from 'texts/driverAgeRange'

export const DriverAgeRange = ({
  range,
  handleChange,
  index,
  rangeType,
  handleRemoveRange,
  isRequired,
}: DriverAgeRangeProps) => {
  const onChange = (value: string, key: string) => {
    const newValue = value.replace(onlyNumbersWithOneDotRegex, '')
    handleChange(index, { ...range, [key]: newValue })
  }

  const isNoFee = rangeType === DriverAgeRangeType.NoFee
  const isPerRentalRange = rangeType === DriverAgeRangeType.PerRental
  const isMaxPriceDisabled = isNoFee || isPerRentalRange

  return (
    <div className={styles.range}>
      <Input
        size="large"
        placeholder={DRIVER_AGE_RANGE.START.PLACEHOLDER}
        value={String(range.ageStart)}
        type="integer"
        maxLength={2}
        typographyName="Button2"
        isRequired={isRequired}
        onChange={(value: string) => onChange(value, 'ageStart')}
        spaceForError="auto"
        label={DRIVER_AGE_RANGE.START.LABEL}
        dataTestId="driver-age-range-start"
      />
      <Input
        size="large"
        placeholder={DRIVER_AGE_RANGE.END.PLACEHOLDER}
        value={String(range.ageEnd)}
        type="integer"
        maxLength={2}
        isRequired={isRequired}
        typographyName="Button2"
        onChange={(value: string) => onChange(value, 'ageEnd')}
        spaceForError="auto"
        label={DRIVER_AGE_RANGE.END.LABEL}
        dataTestId="driver-age-range-end"
      />
      <Input
        size="large"
        placeholder={isNoFee ? '' : DRIVER_AGE_RANGE.FEE.PLACEHOLDER}
        value={isNoFee ? '' : String(range.price)}
        typographyName="Button2"
        onChange={(value: string) => onChange(value, 'price')}
        spaceForError="auto"
        readonly={isNoFee}
        isDisabled={isNoFee}
        label={DRIVER_AGE_RANGE.FEE.LABEL}
        dataTestId="driver-age-range-fee"
      />
      <Input
        size="large"
        value={isMaxPriceDisabled ? '' : String(range.maxPrice)}
        placeholder={
          isMaxPriceDisabled ? '' : DRIVER_AGE_RANGE.MAX_PRICE.PLACEHOLDER
        }
        onChange={(value: string) => onChange(value, 'maxPrice')}
        spaceForError="auto"
        typographyName="Button2"
        readonly={isMaxPriceDisabled}
        isDisabled={isMaxPriceDisabled}
        label={DRIVER_AGE_RANGE.MAX_PRICE.LABEL}
        dataTestId="driver-age-range-max-price"
      />
      <TrashIconWithBg
        color="blue700"
        size="large"
        className={styles.icon}
        onClick={handleRemoveRange}
        dataTestId="driver-age-range-trash-icon"
      />
    </div>
  )
}
